import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Sidebar from '../Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowLeft, 
  faComments, 
  faUserCircle,
  faCalendarAlt,
  faMessage
} from '@fortawesome/free-solid-svg-icons';
import { buildApiUrl } from '../../config/api.config';

const UserReviews = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userReviews, setUserReviews] = useState([]);
  const [userName, setUserName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const fetchUserReviews = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(buildApiUrl(`message/admin/all-reviews/${userId}`), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token'),
        },
      });

      const data = await response.json();
      if (response.ok) {
        setUserReviews(data);
      } else {
        toast.error("Error fetching reviews");
      }
    } catch (error) {
      toast.error("An error occurred while fetching reviews");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(buildApiUrl(`users/admin/getuser/${userId}`), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token'),
        },
      });

      const data = await response.json();
      if (response.ok) {
        setUserName(data.name);
      }
    } catch (error) {
      console.error("Error fetching user details");
    }
  };

  useEffect(() => {
    fetchUserReviews();
    fetchUserDetails();
  }, [userId]);

  return (
    <div className="admin-layout">
      <Sidebar />
      <main>
        <div className="tf-card">
          <header style={{ marginBottom: '2.5rem' }}>
            <button 
              onClick={() => navigate(-1)} 
              className="tf-btn" 
              style={{ background: 'rgba(255,255,255,0.05)', color: 'var(--tf-text-muted)', padding: '0.5rem 1rem', fontSize: '0.85rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Back to Desk
            </button>
            
            <div className="tf-flex" style={{ gap: '1rem', alignItems: 'center' }}>
              <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'linear-gradient(135deg, var(--tf-primary) 0%, #ff6b6b 100%)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem' }}>
                <FontAwesomeIcon icon={faUserCircle} />
              </div>
              <div>
                <h1 className="tf-heading-md" style={{ margin: 0, fontSize: '1.8rem' }}>{userName}'s Messages</h1>
                <p style={{ color: 'var(--tf-text-muted)', margin: 0 }}>Review history for this specific customer account</p>
              </div>
            </div>
          </header>

          {isLoading ? (
            <div className="tf-flex-center" style={{ padding: '6rem 2rem', flexDirection: 'column', gap: '1.5rem' }}>
              <div className="tf-spinner"></div>
              <p style={{ color: 'var(--tf-text-muted)', fontWeight: '500' }}>Retrieving conversation history...</p>
            </div>
          ) : userReviews.length === 0 ? (
            <div className="tf-empty-state">
               <FontAwesomeIcon icon={faComments} size="3x" style={{ marginBottom: '1.5rem', opacity: 0.1 }} />
               <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>No messages recorded for this user.</p>
               <button onClick={() => navigate(-1)} className="tf-btn tf-btn-primary" style={{ marginTop: '1.5rem' }}>Return to Inbox</button>
            </div>
          ) : (
            <div className="tf-list-container">
              <div className="tf-list-header" style={{ gridTemplateColumns: '1.5fr 3fr 1.5fr', gap: '1.5rem', padding: '1.25rem 2rem' }}>
                <span>POSTED ON</span>
                <span>MESSAGE CONTENT</span>
                <span style={{ textAlign: 'right' }}>STATUS</span>
              </div>

              <div className="tf-grid" style={{ gap: '0' }}>
                {userReviews.map((review) => (
                  <div key={review._id} className="tf-list-item" style={{ gridTemplateColumns: '1.5fr 3fr 1.5fr', gap: '1.5rem', padding: '1.5rem 2rem' }}>
                    <div className="tf-flex" style={{ gap: '0.75rem', color: 'var(--tf-text-muted)', fontSize: '0.9rem' }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: 'var(--tf-primary)', opacity: 0.7 }} />
                      {new Date(review.date).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </div>
                    <div style={{ color: 'var(--tf-text-white)', lineHeight: '1.6', fontSize: '0.95rem' }}>
                      "{review.message}"
                    </div>
                    <div style={{ textAlign: 'right' }}>
                       <span style={{ 
                         padding: '0.4rem 1rem', 
                         borderRadius: '20px', 
                         fontSize: '0.75rem', 
                         fontWeight: '700', 
                         textTransform: 'uppercase',
                         background: review.status === 'pending' ? 'rgba(255, 65, 53, 0.1)' : 'rgba(16, 185, 129, 0.1)',
                         color: review.status === 'pending' ? 'var(--tf-primary)' : 'var(--tf-success)',
                         border: review.status === 'pending' ? '1px solid rgba(255, 65, 53, 0.2)' : '1px solid rgba(16, 185, 129, 0.2)'
                       }}>
                         {review.status}
                       </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default UserReviews;
